import React from 'react';

import { capitalize } from '@mui/material';

import { IInboundTaskProcessedItem, TableConfig } from 'commons/types';
import { formatDate } from 'commons/utils/formatDate';

export const summaryTableConfig: TableConfig = [
  {
    header: 'Bin',
    key: 'bin',
  },
  {
    header: 'Batch',
    key: 'inventory_number',
  },
  {
    header: 'Bin Type',
    element: (receiveActual: IInboundTaskProcessedItem): React.ReactElement => {
      return <div>{capitalize(receiveActual.bin_type)}</div>;
    },
  },
  {
    header: 'Expiry Date',
    element: (receiveActual: IInboundTaskProcessedItem): React.ReactElement => {
      const date = formatDate(receiveActual.expiry_date);
      return <div>{date}</div>;
    },
  },
  {
    header: 'Qty',
    key: 'quantity',
  },
];
